import {gql} from 'apollo-angular';


import { promisesMatchingGiftsFragment } from '../fragments/promises-matching-gifts.gql';
import { distributionsFragment } from '../fragments/distributions.gql';
import { promisesSponsorshipsFragment } from '../fragments/promises-sponsorships.gql';
import { teamFragment } from '../fragments/team.gql';

// This basically combines all other gqls, could be done smartly by combining other gqls
export const eventRelatedGql = gql`
  query EventRelatedQuery($participantId: [Int!],) {
    Participant (participantId: $participantId){
      participantId
      teamRoleType {
        description
        teamRoleTypeId
        activeFlag
        name
      }
      event {
        eventId
        eventDate
        eventTime
        timezone
        sysEventTypeName
        program {
          name
          programGroup {
            name
            baseUrl
            donateUrl
            imageUrl
            mobileDonationUrl
            pciFundraiserUrl
            fundraisingToolsUrl
            fundraisingToolsHelpUrl
          }
        }
      }
      participantEventUrls {
          participantEventUrl
          dateCreation(orderBy: ASC)
      }
      individualConstituent {
        allergies
        firstName
        currentMedicalConditions
        lastName
        dateOfBirth
        individualConstituentId
        currentMedications
        middleInitial
        suffix
        insuranceCompany
        imageId
        imagePath
        prefixType {
          cmgmtPrefixTypeId
          name
        }
        constituentAddresses {
          postalCode
          city
          constituentAddressId
          address1
          address2
          address3
          primaryFl
          country
          county
          state
          addressType {
            addressTypeId
            name
            description
          }
        }
        constituentEmails {
          constituentEmailId
          email
          primaryFl
          emailType {
            cmgmtEmailTypeId
            name
            description
          }
        }
        constituentPhones {
          constituentPhoneId
          areaCode
          countryCode
          primaryFl
          phoneNumber
          phoneType {
            cmgmtPhoneTypeId
            name
            description
          }
        }
        constituentImageLibraries {
          imagePath
          imageName
          constituentImageLibraryId
        }
        constituentAddressBooksConnection {
          totalPages
          totalElements
        }
      }
      ${promisesSponsorshipsFragment}
      ${promisesMatchingGiftsFragment}
      ${distributionsFragment}
      adoptedEvent {
        adoptedEventId
        sysThemeTypeName
        bannerPath
        allowMobileCheckDonations
        allowMobileCreditCardDonations
        isSinglePage
        fundraisingTips {
          sysTemplateTypeName
          content
          subject
          pdefProgramGroupTemplateId
          pdefProgramTemplateId
          sysTemplateTypeDescription
        }
      }
      fundraiser {
          fundraiserId
          fundraiserPageId
          fullUrl
          kickoffDate
          kickoffDateStr
          closeDonationsDate
          canAcceptDonations
          activeFacebookFundraiserProfiles {
            facebookFundraiserId
          }
          facebookDonationsAmount
          fundraisingGoal
          fundraisingMinimum
          fundraiserPosition
          fundraiserCount
          displayOnLeaderBoardFlag
          donationsReceived
          outstandingMatchingGifts
          outstandingSponsorships
          fundraiserType {
            name
          }
          fundraiserPageTemplateType {
            name
          }
          fundraiserPosts {
            fundraiserPostId
            publishedFl
            urlKey
            rawHtmlContent
            htmlContent
            publishedDate
            title
            fundraiserPostComments {
              comment
            }
          }
          fundraiserNewsFeeds {
            htmlContent
            fundraiserNewsFeedId
          }
      }
      emergencyContacts {
        emergencyContactId
        emergencyContactPhones {
          phoneType {
            cmgmtPhoneTypeId
          }
          cmgmtEmergencyContactPhoneId
          areaCode
          phoneNumber
          primaryFl
        }
        emergencyContactType {
          emergencyContactTypeId,
          name,
          description
        }
        constituentRelationshipType {
          constituentRelationshipTypeId,
          name,
          description
        }
        contactFirstName
        contactLastName
      }
      ${teamFragment}
    }
 }  
`;
